//LIBRARIES
import { useTranslation } from "react-i18next";

export const TableConfigData = () => {
  const { t } = useTranslation();
  return {
    tableConfig: {
      rentals: {
        metadata: {
          isPageable: true,
          isScrollable: false,
        },
        columns: [
          {
            key: "fullName",
            label: t("tableHeaders.fullName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "slotId",
            label: t("tableHeaders.door"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "date",
            label: t("tableHeaders.date"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "startTime",
            label: t("tableHeaders.startTime"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "endTime",
            label: t("tableHeaders.endTime"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "duration",
            label: t("tableHeaders.duration"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "",
            label: "",
            orientation: "right",
            hasAction: true,
          },
          // {
          //   key: "amount",
          //   label: t("tableHeaders.amount"),
          //   orientation: "center",
          //   hasAction: true,
          // },
        ],
      },
      payments: {
        metadata: {
          isScrollable: false,
          isPageable: true,
        },
        columns: [
          {
            key: "fullName",
            label: t("tableHeaders.fullName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "creationDate",
            label: t("tableHeaders.date"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "amount",
            label: t("tableHeaders.amount"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "isRefund",
            label: t("tableHeaders.refund"),
            orientation: "center",
            hasAction: false,
          },
        ],
      },
      invoices_logs: { //DE EDITAT CAND SCHIMB API CALL
        metadata: {
          isScrollable: false,
          isPageable: true,
        },
        columns: [
          {
            key: "fullName",
            label: t("tableHeaders.fullName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "creationDate",
            label: t("tableHeaders.date"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "amount",
            label: t("tableHeaders.amount"),
            orientation: "center",
            hasAction: false,
          },
          {
            key: "isRefund",
            label: t("tableHeaders.refund"),
            orientation: "center",
            hasAction: false,
          },
        ],
      },
      users: {
        metadata: {
          isPageable: true,
          isScrollable: false,
        },
        columns: [
          {
            key: "username",
            label: t("tableHeaders.fullName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "phoneNumber",
            label: t("tableHeaders.phoneNumber"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "date",
            label: t("tableHeaders.users.creationDate"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "veriffSessionId",
            label: "Veriff Session ID",
            orientation: "left",
            hasAction: false,
          },
          {
            key: "userStatus",
            label: t("tableHeaders.userStatus"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "",
            label: "",
            orientation: "right",
            hasAction: true,
          },
        ],
      },
      rentals_logs: {
        metadata: {
          isPageable: true,
          isScrollable: false,
        },
        columns: [
          {
            key: "username",
            label: t("tableHeaders.username"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "fullName",
            label: t("tableHeaders.fullName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "lockerName",
            label: t("tableHeaders.lockersName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "status",
            label: "Status",
            orientation: "left",
            hasAction: false,
          },
          {
            key: "date",
            label: t("tableHeaders.date"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "startTime",
            label: t("tableHeaders.startTime"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "",
            label: "",
            orientation: "right",
            hasAction: true,
          },
        ],
      },
      sms_logs: {
        metadata: {
          isPageable: true,
          isScrollable: false,
        },
        columns: [
          {
            key: "phoneNumber",
            label: t("tableHeaders.phoneNumber"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "fullName",
            label: t("tableHeaders.fullName"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "imei",
            label: t("tableHeaders.imei"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "date",
            label: t("tableHeaders.date"),
            orientation: "left",
            hasAction: false,
          },
          {
            key: "startTime",
            label: t("tableHeaders.startTime"),
            orientation: "left",
            hasAction: false,
          },
        ],
      },
    },
  };
};
